import Config from '#/config'
import i18n from '#/locales'
import axios from 'axios'

const instance = axios.create({
  baseURL: Config.apiBase(),
  authRequired: true,
})

instance.interceptors.request.use(
  (config) => {
    const token = config?.data?.refresh
      ? localStorage.getItem('refresh-token')
      : localStorage.getItem('user-token')

    if (token && config.authRequired) {
      config.headers.Authorization = `Bearer ${token}`
    }

    config.headers['Content-Language'] = i18n.global.locale.value
    config.headers['Accept-Language'] = i18n.global.locale.value
    return config
  },
  error => Promise.reject(error),
)

export default instance
